// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__Ux3oq","value":"Counter_value__Fudsn"};